import { Link, useParams, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import blogsData from "../data/blogsData";
import blogDetailsData from "../data/blogDetailsData";
import "../styles/blogDetails.css";

export default function BlogDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const post = blogsData.find((b) => b.id === id);
  const content = blogDetailsData[id];

  if (!post) {
    return (
      <div className="detail-page">
        <div className="detail-not-found">
          <span>🔍</span>
          <h2>Post not found</h2>
          <p>We couldn't find the article you're looking for.</p>
          <button onClick={() => navigate("/blogs")}>← Back to Blog</button>
        </div>
      </div>
    );
  }

  return (
    <div className="detail-page">
      <div className="detail-container">

        {/* ── Breadcrumb ── */}
        <nav className="detail-breadcrumb">
          <Link to="/">Home</Link>
          <span className="sep">›</span>
          <Link to="/blogs">Blog</Link>
          <span className="sep">›</span>
          <span className="current">{post.title}</span>
        </nav>

        {/* ── Tags ── */}
        <div className="detail-tags">
          <span className="detail-tag">{post.topic}</span>
          {post.category !== post.topic && (
            <span className="detail-tag">{post.category}</span>
          )}
          <span className="detail-read-time">⏱ {post.readTime}</span>
        </div>

        {/* ── Title ── */}
        <h1 className="detail-title">{post.title}</h1>

        {/* ── Meta ── */}
        <div className="detail-meta">
          <span className="detail-author">✍️ {post.author}</span>
          <span className="detail-dot">·</span>
          <span className="detail-date">📅 {post.date}</span>
        </div>

        {/* ── Hero Image ── */}
        <div className="detail-image-wrap">
          <img src={post.image} alt={post.title} className="detail-image" />
        </div>

        {/* ── Article Body ── */}
        <div className="detail-article">
          <p className="detail-excerpt">{post.excerpt}</p>

          <div className="detail-keywords">
            <h3>Topics covered</h3>
            <div className="kw-list">
              {post.keywords.map((kw) => (
                <span key={kw} className="kw-chip">{kw}</span>
              ))}
            </div>
          </div>

          {/* ── Full Content OR placeholder ── */}
          {content ? (
            <div className="detail-markdown">
              <ReactMarkdown>{content}</ReactMarkdown>
            </div>
          ) : (
            <div className="detail-notice">
              <span>📖</span>
              <p>
                Full article content coming soon. Add Markdown to{" "}
                <code>blogDetailsData.js</code> under key{" "}
                <code>"{id}"</code> to populate this page.
              </p>
            </div>
          )}
        </div>

        {/* ── Back button ── */}
        <button className="detail-back-btn" onClick={() => navigate("/blogs")}>
          ← Back to Blog
        </button>

      </div>
    </div>
  );
}